import React from "react";
import { Checkbox, Table } from "evergreen-ui";
import { ColumnConfig } from "../../../../common/tables/config/ColumnConfig";
import { EnumResolver } from "../../../../common/tables/etc/EnumResolver";
import { EnumMapper, ResolvedEnum } from "../../../../common/tables/etc/EnumMapper";
import { TableCellChangedHandler, TableCellFactory } from "../../../../common/tables/factory";
import { VariantTableRow } from "../../../../../../common/tables/product-listing/variants/VariantTableRow";
import { ShopifyProductVariant } from "../../../../../../common/models";

type VariantWithAssignment = ShopifyProductVariant & { _assigned: boolean; _lastAssigned: boolean };

const emptyMapper: EnumMapper = {
    map(): ResolvedEnum {
        return {};
    }
};

class VariantAssignmentEnumMapper extends EnumResolver<VariantTableRow> {
    public resolveEnum(_columnName: keyof VariantTableRow): EnumMapper {
        return emptyMapper;
    }
}

export class VariantAssignmentTableCellFactory extends TableCellFactory<VariantTableRow, VariantWithAssignment> {
    readonly enumResolver: EnumResolver<VariantTableRow> = new VariantAssignmentEnumMapper();

    public renderBodyCell(
        columnConfig: ColumnConfig<VariantTableRow>,
        rowData: VariantWithAssignment,
        onCellChanged: TableCellChangedHandler<VariantTableRow>,
    ): JSX.Element {
        if (columnConfig.columnName === "costMetadataCount") {
            const isDisabled = rowData._assigned && rowData._lastAssigned;
            return React.createElement(
                Table.Cell,
                { className: "jc-body-cell checkbox" },
                React.createElement(Checkbox, {
                    checked: rowData._assigned,
                    disabled: isDisabled,
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                        if (onCellChanged) {
                            onCellChanged(
                                rowData.id,
                                columnConfig.columnName as keyof VariantTableRow,
                                e.target.checked,
                            );
                        }
                    },
                }),
            );
        }

        return super.renderBodyCell(columnConfig, rowData, onCellChanged);
    }

    protected resolveCellData(
        columnConfig: ColumnConfig<VariantTableRow>,
        rowData: VariantWithAssignment,
    ): string {
        const colName = columnConfig.columnName as string;

        if (colName === "costMetadataCount") {
            return rowData._assigned ? "true" : "";
        }

        if (colName === "price") {
            return rowData.price ? `$${rowData.price}` : "";
        }

        return super.resolveCellData(columnConfig, rowData);
    }
}
